import { getIdAndContentTypeFromTopics } from '../../utils'
/* eslint-disable import/no-internal-modules */
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
import Button from '@insided/control/uikit/Button'
import Icon from '@insided/deprecated-preact-components/assets'
import { markPostsAsNotSpam } from '@insided/shared/services/spamService'

const MarkAsNotSpam = ({
  performBulkAction, numberOfSelectedItems
}: BulkActionComponentProps) => (
  <Button
    title={
      <div>
        <Icon icon='checkmark' width={16} height={16} />
        Mark as not spam
      </div>
      }
    size='medium'
    variant='approval'
    className='qa-mark-as-not-spam'
    onClick={() =>
      performBulkAction({
        onClick: async (topics: []) =>
          await markPostsAsNotSpam(getIdAndContentTypeFromTopics(topics)),
        successMessage: numberOfSelectedItems > 1 ? `You’ve marked ${numberOfSelectedItems} posts as not spam` : 'You’ve marked this post as not spam.'
      })}
  />
)

export default MarkAsNotSpam
